import { TemplateResult } from 'lit';

export class FlexibleTableDisplayColumn {
  private renderPath: string;

  private sideHeader: boolean = false;

  private cellRenderer: (data, rowIndex, columnIndex) => string | TemplateResult;

  private flex: string;

  /**
   * @param renderPath Path to data property that should be displayed.
   * Defaults to undefined.
   * @returns this
   */
  public withRenderPath(renderPath: string): this {
    this.renderPath = renderPath;

    return this;
  }

  /**
   * @param sideHeader Specifies if the given column is a side header.
   * Defaults to false.
   * @returns this
   */
  public withSideHeader(sideHeader: boolean): this {
    this.sideHeader = sideHeader;

    return this;
  }

  /**
   * @param cellRenderer Add a custom renderer for the cells in the given column.
   * @returns this
   */
  public withCellRenderer(cellRenderer: (data, rowIndex, columnIndex) => string | TemplateResult): this {
    this.cellRenderer = cellRenderer;

    return this;
  }

  public withFlex(flex: string) {
    this.flex = flex;

    return this;
  }

  public getRenderPath() {
    return this.renderPath;
  }

  public getSideHeader() {
    return this.sideHeader;
  }

  public getCellRenderer() {
    return this.cellRenderer;
  }

  public getFlex() {
    return this.flex;
  }
}

export interface FlexibleTableRow {
  columns: Array<FlexibleTableColumn>;
}

export interface FlexibleTableColumn {
  value: string;
  sideHeader: boolean;
  cellRenderer: () => string | TemplateResult;
  flex: string;
}

export enum FlexibleTableEvent {
  ROW_CLICKED = 'rowClicked',
}

export type AdditionalRowRenderer = (rowData: any) => TemplateResult;
